import request from '@/services/interceptor.js'


export const send_passwordMail = par => {
  return request({
    url: '/api/account/pwdsend/',
    method: 'post',
    data: par
  })
};
export const save_newPassword = par => {
  return request({
    url: '/api/account/pwdreset',
    method: 'post',
    data: par
  })
};
export const save_newAccount = par => {
  return request({
    url: '/api/account/new',
    method: 'post',
    data: par
  })
};
export const activate_newAccount = par => {
  return request({
    url: '/api/account/activate',
    method: 'post',
    data: par
  })
};